// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb1e2b45","241":"c48e11b7","667":"7704af96","676":"7763ad23","879":"b77a7fc1","977":"ee531c17"}[chunkId] + ".chunk.js";
};